import React from "react";
import './book-page.css';
import letstalkmoney from '../../Images/books/letstalkmoney.jpg';

const  Review19 = () => {
  return (
            <div className="book-page-box">
                <div class="book-header ">
                   <div className="book-img">
                   <img src={letstalkmoney} alt="Let's Talk Money "/>
            </div>
                   
            <div class="book-title">
                <h1>Let's Talk Money</h1> 
                <p class="author">by <i>Monika Halan</i></p>        
                <p>  Book review by <i>Mishthi Kainthola</i></p>
            </div>
                  
                <div className="blog-para">
                <p>
                    
                    
                    Let’s Talk Money is a perfect book for people beginning their financial journey. Halan discusses how one can systematically manage their money. She explains the need to remember everything before even considering investing in their finances. The author emphasizes efficiently managing money. The book is conversational, making it quite engaging as a reader as if I were talking to a friend. 

                    <br></br><br></br>
                    
                    The updated version of the book also showcases what the author learned from the COVID-19 pandemic. It highlights how the financial planners and experts– all had to go back to their whiteboards to redo the math. The author emphasizes how uncertain life can be and that one should live each day as if it were the last. Making peace with your own death is another noteworthy aspect the author touches on. This means looking at their loved ones who will be left behind and being responsible about allocating one’s finances in case misfortune were to occur. In calculations of all the disasters, the pandemic indeed was out of the syllabus even for the big think tanks. Halan admits that she rethought and reconsidered her ‘conservative’ self during this time.
                    <br></br><br></br>
                    
                    The lockdown, a situation where the whole world was stalling time, saw something astonishing happen– a pay cut but still an increase in savings. This was all thanks to the basic mode of life everyone was forced to live with. Limited e-commerce movement, a cut on fuel expenses, extra entertainment, luxury items, and something as small as a cup of coffee – all of which contributed to this. The spendings were lesser even for someone who considered themself to be a frugal spender. This was an effect of living life on basics – which forces us to reconsider our spending habits.
                    <br></br><br></br>
                    
                    This book doesn’t throw technical gibberish (with its 7th chapter being called– Let’s De-jargon Investing) but rather explains things in layman’s terms. Halan talks about funds for emergencies, building one’s protection, in case of death, investing, equity, mutual funds, retirement plans, wills, and more in different chapters of this book. It is a must-read to enhance your analytical thinking and analyze your money matters better.
                   
                    
                    </p>
                </div>
        </div>
    </div>


                         
  );
}

export default Review19;
